<template>
  <div class="container">
    <div class="info" v-if="info.id">
      <el-descriptions title="主理人信息">
        <el-descriptions-item label="头像">
            <el-image
                style="width: 100px; height: 100px"
                :src="info.avatar"
                fit="cover"
                :preview-src-list="[info.avatar]"
              ></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="昵称">{{
          info.nick_name
        }}</el-descriptions-item>
         <el-descriptions-item label="身份">{{
          info.enroll_role || ''
        }}</el-descriptions-item>
        <el-descriptions-item label="电话">{{
          info.phone || ''
        }}</el-descriptions-item>
        <el-descriptions-item label="擅长">{{
          info.specialty_tags || ''
        }}</el-descriptions-item>
        
      </el-descriptions>

    </div>
    <div></div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      id: "",
      info: {},
      activeName: "bind",
      manager: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetails();
  },

  methods: {
    handleClick(tab) {
      this.$refs[tab.name].load();
    },
    getDetails() {
      this.$axios({
        url: "/user/enrollUser/queryById",
        params: {
          id: this.id,
        },
      }).then((res) => {
        this.info = res.data.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.info {
  margin-bottom: 30px;
}
</style>